import splide from "../utils/splide";
require("fslightbox");

export default function gallery(perPage = 3) {
    const gallery = document.getElementById("gallery");
    if (gallery) {
        const gallerySplide = splide(gallery, { perPage });
        gallerySplide.mount();
    }
}
